<div class="modal-header"
  [ngClass]="headerClass ? ('modal-header-' + headerClass) : ''">
  <h3 class="p-large">
    @if (iClass) {
      <i class="{{iClass}} mr-3"></i>
    }
    <span [innerHTML]="modalTitle | translate"
    [ngClass]="{'hidden-xs' : modalTitleXs}"></span>
    @if (modalTitleXs) {
      <span [innerHTML]="modalTitleXs | translate"
      class="hidden-lg hidden-md hidden-sm"></span>
    }
    @if (detail) {
      <span>
        -
        <strong>{{detail | translate}}</strong>
      </span>
    }
    @if (badgeText) {
      <sb-badge
        [badgeClass]="badgeClass"
        [iconName]="badgeIcon"
        [message]="badgeText"
      class="ml-3"></sb-badge>
    }
  </h3>
  @if (!isCloseHidden) {
    <sb-button
      buttonClass="link"
      [isAutoSize]="true"
      [isDisabled]="isCloseDisabled"
      iconName="close"
      (onClick)="close()">
    </sb-button>
  }
</div>